import React from 'react';
import { QuoteProvider } from './Quote';
import { OnRequestAnimFrameOnScroll } from './onRequestAnimFrameOnScroll';
import { CookieAcceptanceProvider } from './CookiesAcceptance';
import { NavigationDropdownStateProvider } from './NavigationDropdownState';
import { DebugProvider } from './Debug';
import { BaseLayoutProvider } from './BaseLayoutState';

export default function Store({ children }) {
  return (
    <CookieAcceptanceProvider>
      <QuoteProvider>
        <NavigationDropdownStateProvider>
          <DebugProvider>
            <BaseLayoutProvider>
              <OnRequestAnimFrameOnScroll>{children}</OnRequestAnimFrameOnScroll>
            </BaseLayoutProvider>
          </DebugProvider>
        </NavigationDropdownStateProvider>
      </QuoteProvider>
    </CookieAcceptanceProvider>
  );
}
